export default [
        {
            path: '/home_management',          //首页
            component: (resolve) => require(['@/views/home_management/home_management'], resolve),
            hidden: true,
            meta: {
                title: '首页',
                code:'home_management',
            },
            children: [
                {
                    path: '/',        //首页
                    component: resolve => require(['@/views/home_management/home_management'], resolve),
                    meta: {
                      title: '首页',
                      code:'home_management',
                    }
                },
            ]
        }
    ]


// WEBPACK FOOTER //
// ./src/router/module/home_management.js